// extracted by mini-css-extract-plugin
export default {"container":"Games__container--dKO","category":"Games__category--2qj","game":"Games__game--2xs","gameInner":"Games__gameInner--1rH","jackpotWrapper":"Games__jackpotWrapper--1vK"};